export const getTelLinkFromPhone = (phone) => "tel:+55" + phone.replace(/[^0-9]/g, "");

export const getWhatsappLinkFromPhone = (phone) =>
  "https://wa.me/55" + phone.replace(/[^0-9]/g, "");

/**
 * Obter código do vído do youtube por sua URL.
 *
 * @param {string} url
 */
export const getYoutubeCode = (url) => {
  url = new URL(url);

  let code;
  switch (url.host) {
    case "www.youtube.com":
      code = url.searchParams.get("v");
      break;
    case "youtu.be":
      code = url.pathname.replace(/\/(.+)\/?.*/, "$1");
      break;
  }
  return code;
};

/**
 * Formatar string para URL.
 */
export const formatToURL = (str) => {
  return str
    .normalize("NFD")
    .replace(/\s+/g, "-")
    .replace(/([\u0300-\u036f]|[^0-9a-zA-Z-])/g, "")
    .toLocaleLowerCase();
};
